module.exports = "/images/perfect-paydays-every-time@3x.png?572417bc417fdc71f3c108552d8a40a5";